import { noteVaultFormSchema } from "@/lib/constants";
import { queryClient } from "@/lib/query";
import { request } from "@/lib/request";
import { NoteVault } from "@/lib/types";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

export const useUpdateNoteVault = () => {
  return useMutation({
    mutationFn: async (data: {
      vaultId: string;
      data: z.infer<typeof noteVaultFormSchema>;
    }) => {
      const res = await request.put<{ data: NoteVault | void }>(
        `/internal/notes/vaults/${data.vaultId}`,
        data.data,
      );
      queryClient.invalidateQueries({
        queryKey: ["notes", "vaults"],
      });
      return res.data.data;
    },
  });
};
